export const messages = {
  en: {
    printPayFeeTianlin: {
      receiptTitle: ' Receipt',
      communityName: 'Community Name',
      buildingNum: 'Building No.',
      building: '',
      buildingArea: 'Building Area',
      ownerName: 'Owner Name',
      roomNum: 'Room No.',
      houseCode: 'House Code',
      none: 'None',
      feeName: 'Fee Name',
      startDate: 'Start Date',
      endDate: 'End Date',
      preDegrees: 'Previous Reading',
      curDegrees: 'Current Reading',
      usage: 'Usage',
      unit: 'Unit',
      unitPrice: 'Unit Price',
      subtotal: 'Subtotal (Yuan)',
      total: 'Total:',
      advanceDate: 'Property Fee Advance Date',
      lastAdvance: 'Last Advance',
      advanceRemain: 'Advance Remaining',
      payableAfterDeduction: 'Payable After Deduction',
      remark1: 'Remark 1',
      remark2: 'Remark 2',
      creator: 'Creator',
      reviewer: 'Reviewer',
      butler: 'Customer Butler',
      paymentMethod: 'Payment Method',
      date: 'Date',
      phoneWechat: 'Phone/WeChat',
      actualPayDate: 'Actual Payment Date',
      serviceCenter: 'Property Service Center'
    }
  },
  zh: {
    printPayFeeTianlin: {
      receiptTitle: '收据单',
      communityName: '小区名称',
      buildingNum: '栋号',
      building: '栋',
      buildingArea: '建筑面积',
      ownerName: '户主姓名',
      roomNum: '房号',
      houseCode: '房屋编号',
      none: '无',
      feeName: '费用名称',
      startDate: '起始日期',
      endDate: '结束日期',
      preDegrees: '上期读数',
      curDegrees: '本期读数',
      usage: '本期用量',
      unit: '单位',
      unitPrice: '单价',
      subtotal: '小计(元)',
      total: '合计：',
      advanceDate: '物业费预存日期',
      lastAdvance: '上期预存',
      advanceRemain: '预存剩余',
      payableAfterDeduction: '抵扣预存后应缴',
      remark1: '备注1',
      remark2: '备注2',
      creator: '制单人',
      reviewer: '复核人',
      butler: '客服管家',
      paymentMethod: '缴费方式',
      date: '日期',
      phoneWechat: '手机/微信号',
      actualPayDate: '实缴日期',
      serviceCenter: '物业服务中心'
    }
  }
}

